import { Fragment, useEffect, useState } from "react";
// @mui material components
import Card from "@mui/material/Card";
import CloseIcon from "@mui/icons-material/Close";
import Table from "@mui/material/Table";
import { DataGrid } from '@mui/x-data-grid';
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import Autocomplete from '@mui/material/Autocomplete';
import TableRow from "@mui/material/TableRow";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined"; // Acromegaly React components
import MDBox from "components/MDBox";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Swal from "sweetalert2";
import LoadingOverlay from "react-loading-overlay";
// Acromegaly React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { getForms } from "controllers/MenuController";

import { styled } from "@mui/material/styles";
// Acromegaly React contexts
import { useMaterialUIController } from "context";
import { NavLink, useNavigate, useParams,useSearchParams } from "react-router-dom";
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Toolbar,
  Box,
  CssBaseline,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Switch,
  useMediaQuery,
  Tooltip,
  Checkbox,
} from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import TablePaginationActions from "examples/Tables/TablePaginationActions";
import getText from "Translator";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { displayErrorMessage } from "controllers/validation";
import {
  getCapsules,
  updateCapsuleRowNumbers,
  deleteCapsule,
  editCapsules,
} from "controllers/MenuController";
import { displaySuccessMessage } from "controllers/validation";
import { submitCapsule } from "controllers/MenuController";
import { getUsersList } from "controllers/UserController";
import { deleteUser } from "controllers/UserController";
import UserPermission from "../usres/UserPermission";
import { updateActiveState } from "controllers/UserController";
import Register from "../usres/Register";
import TreeSelect, {
  FreeSoloNode,
  DefaultOption,
  getDefaultOptionProps,
} from "mui-tree-select";
import { getfileswithcapsule } from "controllers/FileController";
import { getAllTitleAndCapsules,getFileAccessUser,storeFileAccessUser,getPageAccessAssistant,storePageAccessAssistant } from "controllers/MenuController";


const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  td: {
    height: 42,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));




class Node {
  constructor(value) {
    this.value = value;
  }

  getParent(data) {
    const parent = ((data) => {
      if ("type" in this.value && this.value.type === "title" ) {
        return null;
      } else if ("type" in this.value && this.value.type === "clinick" ) {
        return (
          data ?
          data.find(({ id }) =>
        this.value.id.split(',')[1] === id
          ) : null
        );
      } else {
        return null;
      }
    })();
    return parent ? new Node(parent) : parent;
  }
  getChildren() {
    
      return this.value.children.map((ch) => new Node(ch));
    
  }
  isBranch() {
    return "type" in this.value && this.value.type === "title" ;
  }
  isEqual(to) {
    return to.value.id === this.value.id;
  }
  toString() {
    return this.value.name;
  }
}


const selectOptions = [{id:"select",name:'انتخاب از لیست'},{id:'range',name:'بازه‌ی عددی'}]
const accessOptions = [{id:"edit",name:"ویرایش"},{id:'result',name:'نتایج'}]
const headline = "complaints";
function FilesAccess(props) {
  const [capsules,setCapsules] = useState([]);
  const [capsule, setCapsule] = useState(null);
  const [users,setUsers] = useState([]);
  const [user,setUser] = useState(null);
  const [accessType,setAccessType] = useState(accessOptions[0])
  const [selectType,setSelectType] = useState(selectOptions[0])
  const [selecetedForms,setSelectedForms] = useState([]);
  const [selecetedPages,setSelectedPages] = useState([]);
  const [range,setRanges] = useState("")
  const [controller] = useMaterialUIController();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [datas, setDatas] = useState([]);
  const [open, setOpen] = useState(false);
  const [openMode, setOpenMode] = useState("");
  const [text, setText] = useState("");
  const [mode, setMode] = useState("new");
  const [search, setSearch] = useState("");
  const [count, setCount] = useState(0);
  const params = useParams();
  let [searchParams, setSearchParams] = useSearchParams();
  const {title} = params
  useEffect(() => {
    if (!controller.authenticated) {
      navigate("/authentication/sign-in", { replace: true });
      return;
    }

    getCapsulesWithTitle();
    getUsers()
    
    
  }, []);
  useEffect(() => {
    // console.log(searchParams.get('nodeId'))
    if(searchParams.get('nodeId'))
    {
      const t = capsules.find(c=>c.id===searchParams.get('nodeId').split(",")[1])
      // console.log(t)
      if(t && 'children' in t && t.children )
      {
        const capsule = t.children.find(ca=>ca.id === searchParams.get('nodeId'))
        // console.log(capsule)
        if(capsule)
        setCapsule(new Node(capsule))
      }
    }
    if(searchParams.get('userId'))
    {
      const u = users.find(u=>u._id===searchParams.get('userId'))
      if(u)
      setUser(u)
    }
    
    
  }, [searchParams,capsules,users]);

  useEffect(() => {
    
    getData("");  
    getPageAccess()
  },[capsule,user,accessType])



  const getCapsulesWithTitle = async () => {
    setLoading(true);
    let result = await getAllTitleAndCapsules(controller.token);
    if (result.success) {
      let data = result.data;
      // console.log("data.children[0]")
      // console.log(data.children[0].children)
      setCapsules(data.children[0].children);
    } else {
      displayErrorMessage(result.message);
    }
    setLoading(false);
  };

  const getUsers = async (rowsPerPagex=-1, pagex=-1, searchx="") => {
    try {
      setLoading(true);
      let newData = {
        rowsPerPage: rowsPerPagex,
        page: pagex,
        search: searchx,
        lang: controller.lang,
      };

      let usersList = await getUsersList(newData, controller);
      setLoading(false);
      if (usersList.success) {
        // console.log(usersList.data);
        setUsers(usersList.data);
      } else {
        displayErrorMessage(controller.lang, usersList.message, usersList.code);
      }
    } catch (err) {
      // console.log(err);
      displayErrorMessage(controller.lang);
    }
  };

 

  const getPageAccess = async () => {
    try {
      // console.log(capsule)
      let newData={};
      // console.log(capsule , user , accessType)
      if(capsule && user && accessType)
      {
        newData.capsule = capsule.value.id.split(',')[2]
        newData.user = user._id
        newData.permission = accessType.id
        let res = await getPageAccessAssistant(controller.lang,newData, controller.token);
        if (res.success) {
          const data = res.data;
          if(data)
          {
            setSelectedPages(data.pages??[])
            setSelectedForms(data.forms??[])
          } 
          else{
            setSelectedPages([])
            setSelectedForms([])

          }
      }
    }
      
      
       
        
      
      
    } catch (err) {
      // console.log(err);
      displayErrorMessage("fa");
    }
  };


  const navigate = useNavigate();
 
  const submitPages = async () => {
    try{
      const newData ={
        user: user._id,
        capsule: capsule.value.id.split(',')[2],
        permission: accessType.id ,
        pages: selecetedPages,
        forms:selecetedForms
      }
      let res = await storePageAccessAssistant(controller.lang,newData, controller.token);
      if (res.success) {
       
          Swal.fire({
          text: getText("insertsuccesfully", controller.lang),
          position: "top-end",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
      } 
    
  } catch (err) {
    // console.log(err);
    displayErrorMessage("fa");
  }
        

  }
  
 
  
  


  
  const getChildrens =(node) =>
          
  node
    ? node.getChildren() : capsules.map((cap) => new Node(cap))
    
    const getParent = (node) => node.getParent(capsules)
  const isBranch = (node) => node.isBranch()


  const getData = async (searchx) => {
    try {
      if(capsule)
        {
      setLoading(true);
      let newData = {
        search: searchx,
        lang: controller.lang,
        capsule: capsule.value.id.split(',')[2],
      };
      
      let data = await getForms(controller.lang, newData, controller.token);
      setLoading(false);
      if (data.success) {
        setDatas(data.data);
      } else {
        displayErrorMessage(controller.lang, data.message, data.code);
      }
    }
    } catch (err) {
      // console.log(err);
      displayErrorMessage(controller.lang);
    }
  };

  const pageSelected = (id)=>{
    // console.log("check",id,selecetedPages)
    const a = selecetedPages.some((value)=>
      {
      
      return value.page === id }
    )
    // console.log("checkstatus",a)
    return a;
  }
  const changePageSelection = (id,form)=>{
    // console.log(id)
    // console.log('selected pages :',selecetedPages)
    const exist = pageSelected(id);
    if(exist)
      {
        // console.log("remove",id)
        setSelectedPages(selecetedPages.filter((value)=>
          value.page !== id
        ))
      }
      else
      {
        // console.log("add",id)
        setSelectedPages([...selecetedPages, {form:form,page:id}])
      }
     
  }

  const formSelected = (id)=>{
    // console.log("check",id,selecetedPages)
    
    const a = selecetedForms.some((value)=>
      {
      return value === id }
    )
    // console.log("checkstatus",a)
    return a;
  }
  const changeFormSelection = (id)=>{
    // console.log(id)
    // console.log('selected pages :',selecetedPages)
    const exist = formSelected(id);
    if(exist)
      {
        // console.log("remove",id)
        setSelectedForms(selecetedForms.filter((value)=>
          value !== id
        ))
      }
      else
      {
        // console.log("add",id)
        setSelectedForms([...selecetedForms, id])
      }
     
  }

  const renderPages = (pages, formParam, formTypeParam) => {
  
    return (
    <TableContainer
                style={{
                  height: pages.length * 43,
                }}
              >
                <Table size="larg" sx={{ minWidth: 500 }}>
                  <TableBody>
                    {pages.map((row, index) => (
                          
                          <StyledTableRow
                            key={row.text}
                            style={{
                              backgroundColor:
                                index % 2 === 0 ? "#fff" : "#f2f2f2",
                            }}
                            
                          >
                            <TableCell
                              align="center"
                              component="th"
                              scope="row"
                              style={{ width: 20 }}
                            >
                              <Checkbox 
                              checked={pageSelected(row.id)}
                              onChange={()=>changePageSelection(row.id,formParam)} 
                              label={row.rownumber} />

                              {/* {row.rownumber} */}
                            </TableCell>
                            <TableCell>
                              <NavLink
                                to={
                                  formTypeParam == 4
                                    ? `/condition/${headline}/${title}/${capsule}/${formParam}/${row.id}/capsule/${formTypeParam}`
                                    : `/pagequestions/${headline}/${title}/${capsule}/${formParam}/${row.id}/${formTypeParam}`
                                }
                                //className={classes.item}
                                key={index}
                              >
                                {row.text}
                              </NavLink>
                            </TableCell>
                            
                          </StyledTableRow>
                      
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            
       
    );
  };

  const convertFormType = (value) => {
    switch (value) {
      case 1: {
        return "main";
      }
      case 2: {
        return "sub";
      }
      case 3: {
        return "help";
      }
      case 4: {
        return "result";
      }
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar
        title={getText("formpermisions", controller.lang)}
        showserch={false}
      />
      <MDBox pb={3} >
        <Card>
          <MDBox>
            <LoadingOverlay
              active={loading}
              spinner
              text={getText("loading", controller.lang)}
            >
              
              <Box dir={'ltr'} sx={{m:2}}>

          <div style={{display:"flex" ,flexWrap:"wrap"}}>
          <TreeSelect
         getChildren={getChildrens}
         getOptionDisabled={(option) => {
           var _a;
           return (
             option.isBranch() &&
             !((_a = option.getChildren()) === null || _a === void 0
               ? void 0
               : _a.length)
           );
         }}
         getParent={getParent}
         isBranch={isBranch}
         isOptionEqualToValue={(option, value) => {
           return option instanceof FreeSoloNode ? false : option.isEqual(value);
         }}
         renderInput={(params) => (
           <TextField
             {...params}
             label="کلینیک"
           />
         )}
         value={capsule}
         onChange={(_, value) => {setCapsule(value)}}
         sx={{ml:1,  mt: 2, mb: 2 ,width:"46%"}}

       />
           <Autocomplete
  disablePortal
  id="combo-box-demo"
  options={users}
  getOptionLabel={(option) => option.name}
  renderInput={(params) => <TextField {...params} label="کاربر"  />}
  value={user}
        onChange={(event, newValue) => {
          setUser(newValue);
        }}
  sx={{ ml: 1, mt: 2, mb: 2 ,width:"46%"}}
  />
  <Autocomplete
  disablePortal
  id="combo-box-demo"
  options={accessOptions}
  getOptionLabel={(option) => option.name}
  renderInput={(params) => <TextField {...params} label="نوع دسترسی پذیری"  />}
  isOptionEqualToValue={(option, value) => {
          return option.id === value.id
        }}
  value={accessType}
        onChange={(event, newValue) => {
          setAccessType(newValue);
        }}
  sx={{ ml: 1, mt: 2, mb: 2 ,width:"46%"}}
  />
  
          

  
          </div>   
          <TableContainer>
                <Table size="larg" sx={{ minWidth: 500 }}>
                  <TableBody>
                    <TableRow style={{ backgroundColor: "#ccc" }}>
                      <TableCell style={{ width: 60 }} align="center" >
                        {getText("row", controller.lang)}
                      </TableCell>
                      <TableCell>{getText("text", controller.lang)}</TableCell>
                     
                    </TableRow>
                    {datas.map((row, index) => (
                     <Fragment key={row+"-"+index}>
                        {!(headline !== "complaints" && row.formType == 4) && (
                            <>
                            <StyledTableRow
                              key={row.id}
                              style={{
                                backgroundColor: "#f7f7f7",
                              }}
                            >
                              
                              <TableCell
                                align="center"
                                component="th"
                                scope="row"
                              >
                                {convertFormType(row.formType)}
                                
                              </TableCell>
                              <TableCell>

                                {/* <NavLink
                              to={"/admin/capsule/" + title + "/" + row.id}
                               activeClassName="active"
                              key={index}
                            > */}
                           <Checkbox 
                              checked={formSelected(row.id)}
                              onChange={()=>changeFormSelection(row.id)} 
                              label={row.rownumber} 
                              />
                                {`${row.text}`}
                                {/* </NavLink> */}
                              </TableCell>
                              </StyledTableRow>
                            {row.pages.length > 0 && (
                              <StyledTableRow
                                key={row.name}
                                style={{
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <TableCell
                                  component="th"
                                  scope="row"
                                  style={{ width: 60 }}
                                ></TableCell>
                                <TableCell colSpan={2}>
                                  {renderPages(row.pages, row.id, row.formType)}
                                </TableCell>
                              </StyledTableRow>
                            )}
                            </>
                          )}
                        </Fragment>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
          </Box>

        

        
      {selectType.id === "range" ?<div style={{display:"flex",margin:10}}>
      
      <TextField id="outlined-basic" label="بازه عددی" variant="outlined"  value={range} onChange={(e)=>{
        setRanges(e.target.value)
      }} />

    </div>:<></>}
        <Button  style={{color: 'white',margin:10 }} variant="contained" onClick={()=>submitPages()}>ثبت دسترسی ها </Button>
            </LoadingOverlay>
          </MDBox>
        </Card>
      </MDBox>
      
  
    </DashboardLayout>
  );
}

export default FilesAccess;
